export enum ServiceLine {
  LAUNDRY_SERVICE = 'laundry',
  SHOE_SERVICE = 'shoes',
  FINERY = 'finery',
  WASH_BAG = 'washbag',
}
